import { makeStyles } from '@material-ui/core/styles';

import { SPOTLIGHT_TYPE } from './const';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: 'white',
      borderRadius: ({ type }) => getBorderRadius(type),

      opacity: 1,
      transition: theme.transitions.create(['opacity'], {
        duration: theme.transitions.duration.shortest,
      }),

      '&$hidden': {
        display: 'none',
        pointerEvents: 'none',
      },
    },
    hidden: {},
  }),
  { name: 'Backdrop' }
);

const getBorderRadius = (type) => {
  switch (type) {
    case SPOTLIGHT_TYPE.circle:
      return '50%';
    case SPOTLIGHT_TYPE.pill:
      return '256px'; // HINT: arbitrary number, can be increased for taller spotlights
    case SPOTLIGHT_TYPE.rectangle:
      return '0';
    case SPOTLIGHT_TYPE.button:
      return '7px';
    default:
      return '8px';
  }
};
